import { createComponent } from '@mtfe/sweet';
import { eventBus, common } from '@mtfe/sweet-utils';
import { oadLX } from '@mtfe/sweet-oad';
import { Tabs, Describe } from '@mtfe/sweet-components';
import style from './style.less';
import tpl from './dom.html';
import store from '../../store/index';
import InnerPoi from '../common/InnerPoi/script';
import { getOnClickEventName } from '../../utils/index';

const { createUniqueId } = common;
const { storeCoupon, storeCommon } = store;
const { storeOptionalWelfare } = storeCoupon;
const timesID = createUniqueId();

const OptionalWelfareReady = (defaultActiveTabKey) => {
    eventBus.$on('OptionalWelfareReady', () => {
        const clickEventName = getOnClickEventName(defaultActiveTabKey);
        eventBus.$emit(clickEventName);
    });
};

const describeOptionalWelfare = new Describe('OptionalWelfare', 'waimai_i8ewucf4');
const OptionalWelfare = () => {
    const { isShowCoupon, isShowRedBag } = storeCommon;
    const { effectData, tabsInfo, poiData } = storeOptionalWelfare;

    const tabInfo = tabsInfo.map((item) => {
        const { recallBizId } = item;
        const resItem = { ...item, key: recallBizId, label: item.text };
        resItem.innerComponent = InnerPoi({
            listInfo: poiData[recallBizId],
        });
        return resItem;
    });

    const defaultActiveTabKey = tabInfo[0].key;

    const data = {
        times: effectData.leftRecvNum,
        timesID,
        tabs: Tabs({
            isSticky: true,
            defaultActiveTabKey,
            tabInfo,
            onTabBarClick: (key) => {
                const eventName = getOnClickEventName(key);
                eventBus.$emit(eventName);
            },
            stickMargin: isShowCoupon && isShowRedBag ? 150 : 0,
            oadLX,
        }),
    };
    const events = {};
    OptionalWelfareReady(defaultActiveTabKey);
    const component = createComponent(tpl, { data, style }, events);
    return component;
};

const changeTimes = (times) => {
    const { effectData } = storeOptionalWelfare;
    const currentTime = times === undefined ? effectData.leftRecvNum : times;
    const timesDom = document.getElementById(timesID);
    if (timesDom) {
        timesDom.innerHTML = currentTime;
    }
};

OptionalWelfare.changeTimes = changeTimes;
OptionalWelfare.describe = describeOptionalWelfare;
eventBus.$on('OptionalWelfare-changeTimes', (times) => {
    changeTimes(times);
});
export default OptionalWelfare;
